const objectPreviewFilesKey = Symbol('object-preview-key')
const downloadFileInjectionKey = Symbol('download-file-inject')

export const useObjectPreview = () => ({
    objectPreviewFilesKey,
    downloadFileInjectionKey,
})
